module.exports = __webpack_public_path__ + "static/img/alksaijsx223.b0288b54.jpg";